import { isDefined } from "../types/index.js";

//#region src/module/cookies/util.ts
function formatCookie(key, value, config) {
	if (key.trim() === "") throw new Error("Key may not be empty");
	return [`${key}=${value}`, ...Object.entries(config ?? {}).map(([configKey, configValue]) => {
		if (typeof configValue === "undefined") return;
		if (configValue === true) return configKey;
		if (configValue instanceof Date) configValue = configValue.toUTCString();
		return `${configKey}=${configValue}`;
	})].filter(isDefined).join("; ");
}

//#endregion
export { formatCookie };